


















import {Vue,Component,Prop, Watch,Mixins} from 'vue-property-decorator';
import SimpleLookupMobile from '@/components/MobileComponents/EnterpriseFormMobile/SimpleLookupMobile/SimpleLookupMobile.vue';
import { ValidValues } from '../../../../store/models/EnterpriseForm/EnterpriseFormValidValues';
import * as personnelService from '@/store/Services/personnelService';
import BookmarkMixin from '@/components/Cartable/EnterpriseForm/BookmarkComponents/BookmarkMixin';

@Component({
    components:{SimpleLookupMobile}
})
export default  class  PersonnelListBookmarkMobile extends Mixins(BookmarkMixin){
   
    valueProp = "";
    validValues = [] as  ValidValues[];
    // get defaultValue(){
    //     if(this.tableColumnBookmark)
    //         return this.tableColumnBookmark.defaultValue;
    //     return '';
    // }
    async created(){
        await this.setValidValues();
    }
    async setValidValues(){
        this.validValues.length = 0;
        const allPersonnel =  await personnelService.GetAllPersonnel();
        allPersonnel.forEach(p=>{
            const validVal = {} as ValidValues;
            validVal.item1 = p.personnelId
            validVal.item2 = `${p.firstName} ${p.lastName}`
            this.validValues.push(validVal);
        });
    }
    onValueSelected(value: ValidValues){
        this.value.Id = value.item1;
        this.value.Value = value.item2;
        this.$emit("value-changed",this.englishName);
    }
    onValueChanged(){
        if(this.value)
            if(this.value.Value)
                this.valueProp = this.value.Value;
            else 
                this.valueProp = this.value;
    }
    
}
